// eslint-disable-next-line no-underscore-dangle
export const apiUrl = window._env_.API_URL;

